import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NotificationChannelPreferences } from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShellService {
  protected http = inject(HttpClient);

  getNotificationOptions() {
    return this.http
      .get<{ data: NotificationChannelPreferences }>('/notifications/options')
      .pipe(map((response) => response.data));
  }

  updateNotificationOptions(preferences: NotificationChannelPreferences) {
    return this.http
      .put<{ data: NotificationChannelPreferences }>('/notifications/options', {
        preferences,
      })
      .pipe(map((response) => response.data));
  }

  getPushPublicKey() {
    return this.http
      .get<{ data: string }>('/notifications/push/public-key')
      .pipe(map((response) => response.data));
  }

  subscribePush(subscription: PushSubscriptionJSON) {
    return this.http
      .post<{
        data: unknown;
      }>('/notifications/push/subscriptions', subscription)
      .pipe(map((response) => response.data));
  }

  unsubscribePush(endpoint: string) {
    return this.http.delete<{ data: unknown }>(
      '/notifications/push/subscriptions',
      { body: { endpoint } },
    );
  }
}
